export const SIMILAR_REPORT_CARD_MAX_WIDTH = 420;
export const SIMILAR_REPORT_CARD_MIN_WIDTH = 280;
